import type { paths } from "@web/api-types-merchants/ahapay";
import createClient from "openapi-fetch";
import { apiUrl } from "../config";
import { throwOnErrorMiddleware } from "./middlewares/throw-on-error";

export const merchantsApi = createClient<paths>({
  baseUrl: apiUrl,
});

export type * as MerchantsTypes from "@web/api-types-merchants/ahapay";

merchantsApi.use(throwOnErrorMiddleware);
